const KycType = {
    SET_KYC:'SET_KYC',
    SET_KYC_LIST_TO_VIEW:'SET_KYC_LIST_TO_VIEW',
    SET_ROLE_MASTER:'SET_ROLEMASTER',
    SET_ROLE_LIST_TO_VIEW:'SET_ROLE_LIST_TO_VIEW',
    SET_ALLOWED_CARD_STATUS:'SET_ALLOWED_CARD_STATUS',
    SET_CARD_STATUS_LIST_TO_VIEW:'SET_CARD_STATUS_LIST_TO_VIEW'
  }
  export default KycType;